"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// EXPLAINER: I AM USING <template> BECAUSE WE ARE DEALING WITH PARTIAL HTML CODE. THINK ABOUT IF WE HAD
// A PARTIAL CODE LIKE `<tr><td></td></tr>`. IF WE STUCK THIS INSIDE A DIV, THE DOM PARSER MIGHT TRY AND WRAP `<table>`
// TAGS AROUND IT, AND THAT WOULD BE BAD BECAUSE IT COULD INTERFERE WITH USER CODE.
exports.stringToEl = (html) => {
    const sandbox = document.createElement('template');
    sandbox.innerHTML = html;
    // DO NOT FORGET TO USE THE `.content` ATTRIBUTE BEFORE USING THE ELEMENT FOR QUERY SELECTORS AND OTHER DOM RELATED THINGS. YOU ALWAYS FORGET AND IT EATS UP TOO MUCH TIME WHEN YOU DO.
    return sandbox;
};
//# sourceMappingURL=stringToEl.js.map